  <div class="page-header">
    <div class="page-header-title">{{ 'title.tournaments-active' | translate }}</div>
    <app-search-field></app-search-field>
  </div>
